import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import { browserHistory } from 'react-router';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import { cyan900, cyan500 } from 'material-ui/styles/colors';
import DialogModal from '../home/DialogModal';
import _ from 'lodash';

const propTypes = {
  option: PropTypes.any,
  onSave: PropTypes.func,
  onDelete: PropTypes.func.isRequired,
  onView: PropTypes.func,
};

class EditOption extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogTitle: ' ',
      dialogMessage: ' ',
      dialogActionTitle: ' ',
      required: {
        name: null,
      },
      option: {
        name: '',
        disabled: false,
      },
      open: false,
      edited: false,
      viewRedirect: false,
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillReceiveProps(nextProps) {
    let option = nextProps.option;
    if (nextProps.option.id) {
      option = nextProps.option;
    }
    option.id = (option.id === null) ? 0 : option.id;
    this.setState({ option });
    this.setRequiredParams();
  }
  setRequiredParams() {
    const required = this.state.required;
    const option = this.state.option;
    Object.keys(this.state.required).forEach((paramName) => {
      const param = option[paramName];
      required[paramName] = (param == null || param.length === 0 || param === 0) ? 'This field is required' : null;
    });
    this.setState({ required });
  }
  handleChange(e) {
    const option = this.props.option;
    if (e.target.type === 'checkbox') {
      _.set(option, e.target.name, e.target.checked);
    } else {
      _.set(option, e.target.name, e.target.value);
    }
    this.setState({
      option,
      edited: true,
    });
    this.setRequiredParams();
  }
  handleDeleteOpen() {
    const nextState = this.state;
    nextState.dialogTitle = 'Delete Option';
    nextState.dialogMessage = 'Do you really want to delete this option?';
    nextState.dialogActionTitle = 'Delete';
    nextState.open = true;
    nextState.delete = true;
    this.setState({ nextState });
  }
  navigateToView() {
    if (this.state.edited === true) {
      const nextState = this.state;
      nextState.viewRedirect = true;
      this.setState(nextState);
      this.handleOpen();
    } else {
      browserHistory.push(`/options/view/${this.state.option.id}`);
    }
  }
  handleClose() {
    this.setState({
      open: false,
      edited: false,
      viewRedirect: false,
    });
    if (this.state.viewRedirect) {
      browserHistory.push(`/options/view/${this.state.option.id}`);
    }
  }
  handleOpen() {
    const nextState = this.state;
    nextState.dialogTitle = 'Save Option Changes';
    nextState.dialogMessage = 'Do you really want to save the changes in this option?';
    nextState.dialogActionTitle = 'Save';
    nextState.open = true;
    this.setState({ nextState });
  }
  saveChanges() {
    this.setState({
      open: false,
      edited: false,
      viewRedirect: false,
    });
    switch (true) {
      case (this.state.delete):
        this.props.onDelete(this.props.option.id);
        break;
      case (this.state.edited && this.state.viewRedirect):
        this.props.onView(this.state.option);
        break;
      default:
        this.props.onSave(this.state.option);
        break;
    }
  }
  handleCancel() {
    browserHistory.push('/options?page=1');
  }
  render() {
    const styles = {
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '2%',
        width: '250px',
      },
    };
    return (
      <div>
        <div>
          <DialogModal
            dialogOpen={this.state.open}
            dialogHandleClose={this.handleClose}
            dialogHandleSubmit={() => this.saveChanges()}
            dialogTitle={this.state.dialogTitle}
            dialogMessage={this.state.dialogMessage}
            dialogActionTitle={this.state.dialogActionTitle}
          />
          <div className="float-right">
            <RaisedButton
              label="Cancel"
              style={{ marginRight: '10px' }}
              primary
              onClick={this.handleCancel}
            />
            <RaisedButton
              style={{ marginRight: '10px' }}
              label="View"
              primary
              onClick={this.navigateToView}
            />
            <RaisedButton
              style={{ marginRight: '10px' }}
              label="Delete"
              primary
              onClick={this.handleDeleteOpen}
            />
            <RaisedButton
              label="Save"
              primary
              onClick={this.handleOpen}
            />
          </div>
          <br />
          <TextField
            floatingLabelText="ID"
            floatingLabelStyle={styles.floatingLabelStyle}
            inputStyle={styles.inputStyle}
            value={this.props.option.id}
            disabled
          />
          <br />
          <TextField
            floatingLabelText="Name"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.option.name}
            name="name"
            onChange={this.handleChange}
            style={styles.inputStyle}
            errorText={this.state.required.name}
            errorStyle={{ color: cyan500 }}
          />
        </div>
      </div>
    );
  }
}

EditOption.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

EditOption.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    option: state.options.option,
  };
}

export default connect(mapStateToProps)(EditOption);



// WEBPACK FOOTER //
// ./src/components/options/EditOption.js